import NavLinkColor from '@components/shared/NavLinkColor'
import { addOfferLink } from '@components/shared/Navbar'
import Icon from '@components/shared/Icon'

export default function ({ style }) {
    return <div style={style || {}}>
        <NavLinkColor {...addOfferLink} color="blue" iconLeft={<Icon>add</Icon>} />
    </div>
}